import { Button, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import services from "../../static/services";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    minHeight: "79vh",
    fontFamily: "Nunito",
    background: "#fff",
  },
  grid: {
    width: "100%",
    margin: theme.spacing(0),
  },
  titleContainer: {
    textAlign: "center",
  },
  contactUsButton: {
    marginTop: theme.spacing(2),
  },
  title: {
    fontFamily: "Nunito",
    fontSize: "2.5rem",
    color: theme.palette.primary.main,
    textAlign: "center",
  },
  title2: {
    fontSize: "1.5rem",
    textAlign: "center",
  },
  carouselGrid: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  carousel: {
    width: "90%",
    height: "650px",
    backgroundColor: "black",
    margin: theme.spacing(2),
  },
  carouselInner: {
    height: "100%",
    width: "100%",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "flex ",
  },
  left: {
    flex: "5%",
    height: "100%",
    backgroundColor: "rgb(0, 0, 0, 0.6)",
    display: "grid",
    placeItems: "center",
    color: "white",
  },
  center: {
    flex: "80%",
    height: "20%",
    alignSelf: "flex-end",
  },
  serviceContainer: {
    backgroundColor: "rgb(255,255,255,0.6)",
    width: "fit-content",
    margin: theme.spacing(1),
    padding: theme.spacing(1),
    borderRadius: "10px",
  },
  serviceTitle: {
    color: "black",
    margin: theme.spacing(1),
    fontSize: "2.5rem",
  },
  serviceDesc: { fontSize: "1.5rem", color: "black", margin: theme.spacing(1) },
  right: {
    flex: "5%",
    height: "100%",
    backgroundColor: "rgb(0, 0, 0, 0.6)",
    display: "grid",
    placeItems: "center",
    color: "white",
  },
}));
const Services = (props) => {
  const classes = useStyles();

  const { setCurrPage } = props;

  const [currImg, setCurrImg] = useState(0);

  useEffect(() => {
    setCurrPage("Services");
  }, [setCurrPage]);

  return (
    <div className={classes.root}>
      <Grid container spacing={1} className={classes.grid}>
        <Grid item xs={12}>
          <div className={classes.titleContainer}>
            <h1 className={classes.title}> Our Services</h1>
            <h1 className={classes.title2}>
              We offer a wide variety of services. Below is a list of what we
              provide.
            </h1>
            <h1 className={classes.title2}>Contact us for quotes!</h1>
            <Button
              className={classes.contactUsButton}
              variant="contained"
              color="secondary"
              component={Link}
              to={"/contact-us"}
              onClick={() => setCurrPage("Contact Us")}
            >
              Contact Us
            </Button>
          </div>
        </Grid>
        <Grid item xs={12} className={classes.carouselGrid}>
          <div className={classes.carousel}>
            <div
              className={classes.carouselInner}
              style={{ backgroundImage: `url(${services[currImg].imageURL})` }}
            >
              <div className={classes.left}>
                <ArrowBackIosIcon
                  style={{ fontSize: 30, cursor: "pointer" }}
                  onClick={() => {
                    currImg > 0 && setCurrImg(currImg - 1);
                  }}
                />
              </div>
              <div className={classes.center}>
                <div className={classes.serviceContainer}>
                  <h1 className={classes.serviceTitle}>
                    {services[currImg].name}
                  </h1>
                  {/*} <h1 className={classes.serviceDesc}>
                    {services[currImg].description}
                </h1>*/}
                </div>
              </div>
              <div className={classes.right}>
                <ArrowForwardIosIcon
                  style={{ fontSize: 30, cursor: "pointer" }}
                  onClick={() => {
                    currImg < services.length - 1 && setCurrImg(currImg + 1);
                  }}
                />
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
export default Services;
